import { render, staticRenderFns } from "./IlluConversation.vue?vue&type=template&id=7afff960&"
import script from "./IlluConversation.vue?vue&type=script&lang=js&"
export * from "./IlluConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports